export default "__VITE_ASSET__D8QIGr07__"